module.exports = __webpack_public_path__ + "static/media/social-security-vs-fra.96ceb248.svg";